import { ReactElement } from 'react';

const ErrorComponent = (): ReactElement => {
  return <p>An Error Occurred:</p>;
};

export default ErrorComponent;
